import type { SVGProps } from "react";

export default function SolarToolboxLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={1.5}>
        <rect width="12.051" height="20" x="2" y="18.051" rx="3" transform="rotate(-90 2 18.051)" />
        <path d="M16.52 6C16.52 4.11438 16.52 3.17157 15.9342 2.58579C15.3484 2 14.4056 2 12.52 2H11.4795C9.59387 2 8.65107 2 8.06528 2.58579C7.47949 3.17157 7.47949 4.11438 7.47949 6" />
        <path d="M2 12H5" />
        <path d="M18.7839 12H22" />
        <path d="M8.78388 12H14.9997" />
        <path d="M8.40549 11H5.37839C5.16941 11 5 11.1694 5 11.3784V13.0141C5 13.1689 5.0942 13.308 5.23786 13.3655L5.7677 13.5774C6.4894 13.8661 7.29449 13.8661 8.01618 13.5774L8.54602 13.3655C8.68968 13.308 8.78388 13.1689 8.78388 13.0141V11.3784C8.78388 11.1694 8.61447 11 8.40549 11Z" />
        <path d="M18.4055 11H15.3784C15.1694 11 15 11.1694 15 11.3784V13.0141C15 13.1689 15.0942 13.308 15.2379 13.3655L15.7677 13.5774C16.4894 13.8661 17.2945 13.8661 18.0162 13.5774L18.546 13.3655C18.6897 13.308 18.7839 13.1689 18.7839 13.0141V11.3784C18.7839 11.1694 18.6145 11 18.4055 11Z" />
      </g>
    </svg>
  );
}
